import { useTranslation } from "react-i18next";
import system from "system-components";

import ApprovalWorkflowContent, {
  APPROVAL_WORKFLOW_CONTENT_VARIATIONS
} from "pstat-anywhere/components/document_control/approve_policy/ApprovalWorkflowContent";
import { ExpandablePanel } from "pstat-design-system/Panel";

const WorkflowContainer = system({
  bg: "nav.95",
  width: "100%",
  border: 1,
  borderColor: "nav.80",
  borderRadius: 1,
  overflowX: "auto"
}).extend`
  overflow-x: auto;
`;

export default function ApprovalFlowDetails({
  approvalWorkflow,
  expandedExternal,
  onExpandedChanged
}) {
  const { t } = useTranslation();
  return (
    <ExpandablePanel
      id="approval-signatures-panel"
      headerText={t("documentControl.view.approvalWorkflowDetails.header")}
      expandedExternal={expandedExternal}
      onExpandedChanged={onExpandedChanged}
    >
      <WorkflowContainer>
        <ApprovalWorkflowContent
          title={approvalWorkflow.name}
          steps={approvalWorkflow.steps}
          onUserRowClick={null}
          variation={APPROVAL_WORKFLOW_CONTENT_VARIATIONS.VIEW_ONLY}
          inModal={false}
          currentStepId={null}
        />
      </WorkflowContainer>
    </ExpandablePanel>
  );
}
